import { Middleware } from "redux";
import { INIT_APPLICATION_STARTED } from "../actions/actionTypes";
import { setHeight } from "../actions/customerMethods";
import { getComponentContainer } from "../reducers/config";
import { IState } from "../store/state";
import ResizeObserver from 'resize-observer-polyfill';

const resizeMiddleware: Middleware = store => next => action => {
    switch (action.type) {
        case INIT_APPLICATION_STARTED:
            const ro = new ResizeObserver((entries: ResizeObserverEntry[], observer: ResizeObserver) => {
                for (const entry of entries) {
                    const { width, height} = entry.contentRect;
                    store.dispatch(setHeight({height}));
                }
            });
            ro.observe(getComponentContainer(store.getState() as any as IState));
            break;
    }
    return next(action);
}

export default resizeMiddleware;
